// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getOrganisationDetailsStatus: { data: null },
  companyUsersStatus: { data: null },
  removeUserStatus: { data: null },
  resendInvitationStatus: {data: null}
};
